/**
 * Hook into Alpine so that it is available no matter at which point Alpine loads.
 */
document.addEventListener('alpine:init', () => {
    /**
     * Adds a token Alpine data object to manage the token authentication.
     */
    Alpine.data('button', () => ({
        /**
         * @var bool true when processing and a spinner should be displayed
         */
        processing: false,

        /**
         * @var string name of an action to run
         */
        action: '',

        /**
         * @var string parameter for the action
         */
        actionParam: null,

        /**
         * @var string location of the function to be called (wire, data or store)
         */
        actionType: '',

        /**
         * @var string trigger name of a slider to toggle if present
         */
        trigger: '',

        /**
         * @var bool true if the action should be performed before the trigger
         */
        instant: false,

        /**
         * Initialize the button.
         *
         * @param string action name of an function to run
         * @param string actionParam parameter for the function
         * @param string actionType location of the function to be called (wire = $wire, data = $data or store = $store)
         * @param string trigger name of a slider to toggle if present
         * @param bool   instant true if the action should be performed before the trigger
         *
         * @return void
         */
        init(action, actionParam, actionType='wire', trigger, instant) {
            this.action      = action;
            this.actionParam = actionParam;
            this.actionType  = actionType;
            this.trigger     = trigger;
            this.instant     = instant;
        },

        /**
        * Perform the action of the button.
        *
        * @return void
         */
        perform() {
            if (this.action !== '') {
                this.processing = true;

                switch (this.actionType) {
                    case 'wire':
                        this.$wire[this.action](this.actionParam).then(function(status) {
                            this.processResult(status);
                        }.bind(this));
                        break;

                    case 'data':
                        this.$data[this.action](this.actionParam).then(function(status) {
                            this.processing = false;
                        }.bind(this));
                        break;

                    case 'store':
                        this.$store[this.action](this.actionParam).then(function(status) {
                            this.processing = false;
                        }.bind(this));
                        break;
                }

            }

        },

        /**
         * Process the result of the function called in the peform method.
         *
         * @param bool status Result of the function called in the peform method
         *
         * @return void
         */
        processResult(status) {
            this.processing = false;
            if (status == true) {
                this.$store.slider.hide(this.trigger);
            }
        },
    }));
});
